import { render, staticRenderFns } from "./HijackResetComponent.vue?vue&type=template&id=5cbdfae1"
import script from "./HijackResetComponent.vue?vue&type=script&lang=js"
export * from "./HijackResetComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports